import { useEffect } from "react";
import { initLenis, destroyLenis } from "@/lib/scroll";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import LatestRelease from "@/components/site/LatestRelease";
import Releases from "@/components/site/Releases";
import About from "@/components/site/About";
import Shows from "@/components/site/Shows";
import Visuals from "@/components/site/Visuals";
import InstagramSection from "@/components/site/InstagramSection";
import Newsletter from "@/components/site/Newsletter";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Home() {
  useEffect(() => {
    initLenis();
    return () => destroyLenis();
  }, []);

  return (
    <main data-testid="home-page" className="relative overflow-x-clip bg-[#070709] text-[#f5f3ef] min-h-screen">
      <div className="noise-page grain" />
      <Nav />
      <Hero />
      <Marquee />
      <LatestRelease />
      <Releases />
      <About />
      <Shows />
      <Visuals />
      <InstagramSection />
      <Newsletter />
      <Contact />
      <Footer />
    </main>
  );
}
